import { FC, ReactNode, createContext, useContext, useState } from 'react';

import { Range } from 'types';

import { AvailableRangesViewContextType } from '../types/AvailableRangesViewContextType';
import { availableRangesViewContextInitValue } from '../constants/availabeRangesViewInitValue';

const AvailableRangesViewContext =
  createContext<AvailableRangesViewContextType>(
    availableRangesViewContextInitValue
  );

export const AvailableRangesViewProvider: FC<{
  children: ReactNode;
  availableRanges: Range[];
  page: number;
  rowsPerPage: number;
  totalAvailableRanges: number;
  isLoadingRanges: boolean;
  handleChangePage: (newPage: number) => void; // eslint-disable-line
  handleChangeRowsPerPage: (newRowsPerPage: number) => void; // eslint-disable-line
  handleClickRange: (range: Range) => void; // eslint-disable-line
}> = ({
  children,
  availableRanges,
  page,
  rowsPerPage,
  totalAvailableRanges,
  isLoadingRanges,
  handleClickRange,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const [expandView, setExpandView] = useState<boolean>(true);
  const [expandDirection, setExpandDirection] = useState<string>('up');

  const handleChangeExpandView = (): void => {
    setExpandView((prev) => !prev);
    setExpandDirection(expandView ? 'down' : 'up');
  };

  return (
    <AvailableRangesViewContext.Provider
      value={{
        data: {
          availableRanges,
          page,
          rowsPerPage,
          totalAvailableRanges,
          expandView,
          expandDirection,
          isLoading: isLoadingRanges,
        },
        actions: {
          handleChangeExpandView,
          handleChangePage,
          handleChangeRowsPerPage,
          handleClickRange,
        },
      }}
    >
      {children}
    </AvailableRangesViewContext.Provider>
  );
};

export const useAvailableRangesView = () => {
  const context = useContext(AvailableRangesViewContext);
  if (!context) {
    throw new Error(
      'useAvailableRangesView must be used within a AvailableRangesViewProvider'
    );
  }
  return context;
};
